var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.188 18.802l.505.055h.636l.082-.018l.127-.011q.255-.017.509-.058c1.672-.261 3.044-1.041 4.168-2.307c.037-.05.043-.08 0-.137l-1.436-1.907l-.055-.062l-.063.1a4.46 4.46 0 0 1-1.703 1.49c-.063.036-.1.036-.162-.026l-.687-.673l-.418-.405l-4.124 3.08l.022.017q.012.013.022.013c.793.453 1.67.742 2.577.849m1.46-13.622l-.35-.037h-.592l-.03.008q-.028.009-.064.01q-.135.016-.273.028c-.18.017-.36.033-.538.066a6.8 6.8 0 0 0-3.606 1.87a8 8 0 0 0-.354.37l-.101.11L8.28 9.65l.063-.094a4.46 4.46 0 0 1 1.728-1.508c.056-.03.094-.025.143.019q.327.33.66.652l.22.214l.162.15l4.193-2.999q-.027-.028-.044-.03a6.75 6.75 0 0 0-2.757-.874m-3.475 7.494L6.053 8.59c-.83 1.508-1.11 3.091-.767 4.768a6.8 6.8 0 0 0 2.32 3.902l2.035-1.527l-.02-.03l-.061-.045a4.45 4.45 0 0 1-1.51-1.726c-.032-.056-.025-.087.019-.131l.467-.48zm6.295-1.952l-.575.593v.006l3.07 4.052a6.846 6.846 0 0 0-1.56-8.634l-2.046 1.534l.081.062a4.45 4.45 0 0 1 1.529 1.745c.031.056.031.1-.02.144z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZrx);
export default __webpack_public_path__ + "static/media/zrx.356447a0e43f91a245a23d84ad90bb79.svg";
export { ForwardRef as ReactComponent };